/*
NAME: CustomerList
DESC: Componente responsavel por listar um array de objetos contendo apenas os clientes
props: 
- usuarioLogado: Tipo de usuario logado
- items: Array de objetos contendo todos os usuarios
- items1: Array de objetos contendo apenas os clientes
- refresh: Função que vem de um componente pai para atualizar a lista de clientes através de um get
- RowsPerPage: Quantidade de linhas por pagina na tabela
- loading: Booleano para mostrar ou não o icone de carregando
NOTES:
*/

import { useEffect, useState } from "react";
import DateFormat from "../../usecases/DateFormat";
import ProjectTable from "../basic/ProjectTable";
import { Info, Person } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import { MarkEmailRead } from "@mui/icons-material";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Pages from "../../pages/Pages";
import { useHistory } from "react-router";
import UserTypes from "../../models/UserTypes"
import UserUnlockOrLock from "../../usecases/UserUnlockOrLock";
import strings from '../../values/strings/strings'

function CustomerList({items, refresh, rowsPerPage, loading}) {

    const [itemsList, setitemsList] = useState([])

 
    useEffect(() => {
        if(items){
        let items1 = items
        let userTabela = bindData(items1)
        setitemsList(userTabela)

    }   else {
        setitemsList('Erro ao carregar os dados')
    }
    } , [items])
    const history = useHistory();

    //Componente responsavel pelos dados do cabeçalho da tabela
    const Header = [
        '',
        '',
        `${strings.getString('info_authorized')}`,
        'Status Email',
        `${strings.getString('info_data')}`,
        `${strings.getString('info_equips')}`,
        `${strings.getString('info_tipo')}`,
        `${strings.getString('info_name')}`,
        `${strings.getString('info_email')}`,
        `${strings.getString('info_telephone')}`,
    ]

    //Adicionar gráficos sobre clientes


    //Mapeamento dos dados do array de objetos para listar os dados na tabela
    const bindData = (data) => {
        
        let binded = [];

        binded = data.map((item, i) => {
            let obj = {}

            obj.info = (<IconButton color="info"><Info /></IconButton>)
            obj.autorizado = mudaStatusAutorizacao(item)
            obj.status = usuarioautorizado(item)
            obj.statusemail = autorizaemail(item)
            obj.data = DateFormat(new Date(item.data_cad_server))
            obj.qtdEquipamentos = item.qtd
            obj.tipo = item.tipo
            obj.nome = item.nome
            obj.email = item.email
            obj.telefone = item ? item.telefone : 'Sem telefone cadastrado';
        
            return obj
        })

        return binded
    }

    function mudaStatusAutorizacao(item, i){
        if(item.autorizado === 1){
            return (<IconButton color="success" onClick={()=>statusItem(item, i)} ><LockOpenIcon/></IconButton>)
        }else{
            return (<IconButton color="error" onClick={()=>statusItem(item, i)}><LockIcon/></IconButton>)
        }        
    }

    function statusItem(item, i){
       loading = true
       UserUnlockOrLock(item).then(() => {
           let newItem = {...item}
           newItem.autorizado === 1 ? newItem.autorizado = 0 : newItem.autorizado = 1
           items[i] = newItem
           let binded = bindData(items)
           setitemsList(binded)        
        }).finally(() => {
            loading = false
        })
    }

    function usuarioautorizado(item){ // Exibição do icone de usuario autorizado ou não
        if(item.autorizado	=== 1){
            return (<IconButton color="success" ><Person/></IconButton>)
        }else{
            return (<IconButton color="error" ><Person/></IconButton>)
        }
    }

    function autorizaemail(item) {
        if(item.emailconfirmado === 1) {
            return (<IconButton color="success" ><MarkEmailRead /></IconButton>)
        } else {
            return (<IconButton color="error"><EmailIcon /></IconButton>)
        }
    }

    

   return (
    <ProjectTable 
    rowsPerPage={rowsPerPage} 
    style={{flex:1, width:'100%', maxWidth:'100%'}} 

    loading={loading}   
    headers={Header} 
    items={itemsList} 
    onRefresh={refresh} 
    title={strings.getString('screen_list_customers')}
   />
   
   );

}

export default CustomerList;